class ListLocationsFilter {
    constructor() {
        this._init();
    }

    private _init() {
        const filterItems = document.querySelectorAll('.list-locations__filterItem');
        if (filterItems) {
            filterItems.forEach(item => {
                item.addEventListener('click', () => {
                    const stateInput = item.querySelector('input')?.checked;
                    if (stateInput === true) {
                        item.querySelector('input')?.removeAttribute('checked');
                    } else {
                        item.querySelector('input')?.setAttribute('checked', 'true');
                    }
                    let currentPagePath = window.location.pathname;
                    const filterActive = document.querySelectorAll('.list-locations__filterItem input:checked');
                    filterActive?.forEach((input, index) => {
                        const inputElement = input as HTMLInputElement; // Type assertion
                        let separator = '&';
                        if (index === 0) {
                            separator = '?';
                        }
                        currentPagePath = currentPagePath + separator + "filter[]=" + inputElement.value;
                    });
                    window.location.href = currentPagePath;
                });
            });
        }
    }
}

// Export pour pouvoir l'utiliser dans d'autres fichiers si nécessaire
export default ListLocationsFilter;

// Initialisation
document.addEventListener('DOMContentLoaded', () => {
    new ListLocationsFilter();
});
